import {
  createListenerMiddleware,
  ListenerEffectAPI,
  ThunkDispatch,
  UnknownAction,
} from '@reduxjs/toolkit'
import { getType } from 'typesafe-actions'

import type { State } from './index'

/**
 * Side effects that used to be expressed as redux-loop `Cmd`s returned from
 * the reducers now live in listeners registered against the same actions.
 * Reducers stay pure; the listener runs after the reducer, which is exactly
 * when redux-loop used to run the command.
 */
export const listenerMiddleware = createListenerMiddleware()

export type ListenerApi = ListenerEffectAPI<
  State,
  ThunkDispatch<State, unknown, UnknownAction>
>

/**
 * Registers an effect for a typesafe-actions action creator. The state seen
 * via `api.getOriginalState()` is the state the reducer was called with, which
 * is what the `Cmd` argument lists used to close over.
 */
export function on<AC extends (...args: any[]) => { type: string }>(
  actionCreator: AC,
  effect: (action: ReturnType<AC>, api: ListenerApi) => void | Promise<void>,
) {
  listenerMiddleware.startListening({
    type: getType(actionCreator as any),
    effect: effect as any,
  })
}
